import * as React from 'react';

// UI Components
import { HeaderJourneysPage } from '@src/ui';

export function HeaderJourneyList(): JSX.Element {
  return <HeaderJourneysPage />;
}
